import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import axios from "axios";
import configs from "@/config/baseConfig";
import "./assets/css/common.less";
import "./utils/rem";
import "./utils/action";
import Storage from "vue-ls";
import { Toast, Notify } from "vant";
import headNavBar from "@/components/head-nav-bar";
import "@/permission";
import bootstrap from "./utils/bootstrap";
// import { cacheSession } from "@/utils/common";
import * as common from "@/utils/common.js";
Vue.use(headNavBar);

Vue.config.productionTip = false;
Vue.prototype.$config = configs;
Vue.prototype.$common = common;
const storageOptions = {
  namespace: "opu_", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
};

Vue.use(Storage, storageOptions);
Vue.use(Toast, Notify);

axios("/config.json").then(result => {
  configs.http.serverUrl = result.data.serverUrl;
  new Vue({
    router,
    store,
    created() {
      bootstrap();
    },
    render: h => h(App),
  }).$mount("#app");
});
